<script setup>
import { ref, computed, watch, getCurrentInstance } from 'vue';
import ComponentEditorBtnGroup from "../ComponentEditorBtnGroup.vue";
import Button from "../../common/Button.vue";

const { proxy } = getCurrentInstance();
const store = proxy.$store;

// --- State ---

const currentHeading = ref('');

// --- Computed ---

const component = computed(() => store.state.componentRoot.component);

// --- Methods ---

const updateView = () => {
    // Accessing directly via proxy to ensure we aren't using a stale reference
    const routeName = proxy.$route.name;
    const tableName = proxy.$route.params.component;

    if (routeName === 'componentSettings') {
        currentHeading.value = 'Settings';
    } else if (routeName === 'componentFields') {
        currentHeading.value = 'Fields';
    } else {
        currentHeading.value = '';
    }

    if (tableName) {
        store.dispatch('componentRoot/init', {
            tableName: tableName
        });
    }
};

const goToListing = () => {
    if (component.value?.tableName) {
        proxy.$router.push({
            name: 'list',
            params: { component: component.value.tableName }
        });
    }
};

// --- Watchers ---

// Watch the proxy's route directly
watch(
    () => proxy.$route,
    () => {
        updateView();
    },
    { immediate: true, deep: true }
);
</script>

<template>
    <div class="d-flex h-100 overflow-auto flex-column">
        <header
            v-if="currentHeading"
            :key="'header-' + proxy.$route.fullPath"
            class="d-flex align-items-center border-bottom"
        >
            <span class="ms-2 flex-fill d-flex align-items-center small">
                <Button class="btn-sm lh-1 me-1 p-1" @click.native="goToListing">
                    <small>{{ component?.title }}</small>
                </Button>

                <i class="bi-chevron-compact-right"/>

                <small class="px-2 d-inline-block">{{ currentHeading }}</small>
            </span>

            <ComponentEditorBtnGroup/>
        </header>

        <router-view
            :key="proxy.$route.params.component"
            class="overflow-auto"
        />
    </div>
</template>